module.exports = __webpack_public_path__ + "img/norfolkisland.f7826f20.svg";